import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'customDate'
})
export class CustomDatePipe implements PipeTransform {

    constructor(private datePipe: DatePipe) {}

    transform(value: any, format?: string, timezone?: string, locale?: string): string | null {
        if (value === null || value === undefined || value === '' || value == 0 || (value instanceof Date && value.getTime() === 0)) {
            return '0000-00-00 00:00:00';
        }

        return this.datePipe.transform(value, format, timezone, locale);
    }
}